module.exports = __webpack_public_path__ + "img/profile_credential_008.c65bfabc.png";